<template>
  <div>
    <div class="py-10 chapter-color">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Tools zur Studie
            </div>
            <div
              class="text-uppercase headline pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Tools zur Studie
            </div>

            <v-divider
              style="border-color: #7D9B38; border-width: 5px; width:20%; display: inline-block; border-style: dotted none none none"
              class="mb-4"
            ></v-divider>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-row cols="12" md="6">
            <v-col cols="12" md="4">
              <v-card class="text-center ma-2" flat height="100%">
                <v-avatar size="164" class="mt-4">
                  <v-img src="/images/Icon-Datenanalyse.svg"></v-img>
                </v-avatar>
                <v-card-title
                  class="justify-center body-1 font-weight-medium hidden-md-and-down"
                >
                  Datenanalyse-Tool
                </v-card-title>
                <v-card-title
                  class="justify-center body-2 font-weight-medium hidden-lg-and-up"
                >
                  Datenanalyse-Tool
                </v-card-title>
                <v-card-text
                  >Gibt es bei der Digitalisierung Unterschiede zwischen
                  Organisationen in Bayern und Nordrhein-Westfalen? Oder gehen
                  junge Non-Profits bei der Digitalisierung strategischer vor
                  als langjährig etablierte Organisationen? Finden Sie in
                  unseren Daten die Antworten auf Ihre Fragen.</v-card-text
                >
                <v-card-actions class="pa-6 pt-0 justify-center">
                  <v-btn
                    color="accent"
                    :to="{ name: 'comparison' }"
                    min-width="90%"
                    depressed
                    rounded
                    contain
                    >Zum Analyse-Tool</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="text-center ma-2" flat height="100%">
                <v-avatar size="164" class="mt-4">
                  <v-img src="/images/Icon-Schnellcheck.svg"></v-img>
                </v-avatar>
                <v-card-title
                  class="justify-center body-1 font-weight-medium hidden-md-and-down"
                >
                  Digital-Schnellcheck
                </v-card-title>
                <v-card-title
                  class="justify-center body-2 font-weight-medium hidden-lg-and-up"
                >
                  Digital-Schnellcheck
                </v-card-title>

                <v-card-text
                  >Sie wollen wissen, wie Ihre eigene Organisation hinsichtlich
                  IT und Digitalisierung aufgestellt ist? Dann beantworten Sie
                  in wenigen Minuten ein paar Fragen in unserem Schnellcheck und
                  vergleichen Sie sich mit anderen Organisationen.</v-card-text
                >
                <v-card-actions class="pa-6 pt-0 justify-center">
                  <v-btn
                    color="accent"
                    :to="{ name: 'benchmarking' }"
                    min-width="90%"
                    depressed
                    rounded
                    >Zum Schnellcheck</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card class="text-center ma-2" flat height="100%">
                <v-avatar size="164" class="mt-4">
                  <v-img src="/images/Icon-Ueber.svg"></v-img>
                </v-avatar>
                <v-card-title
                  class="justify-center body-1 font-weight-medium hidden-md-and-down"
                >
                  Über die Studie
                </v-card-title>
                <v-card-title
                  class="justify-center body-2 font-weight-medium hidden-lg-and-up"
                >
                  Über die Studie
                </v-card-title>
                <v-card-text
                  >Über 5.000 Organisationen aus dem gesamten Bundesgebiet haben
                  an unserer Umfrage teilgenommen. Welche Non-Profits den
                  Fragebogen beantwortet haben, wie wir die Daten erhoben haben
                  oder mit welchen Methoden wir die Daten analysiert haben,
                  finden Sie hier.</v-card-text
                >
                <v-card-actions class="pa-6 pt-0 justify-center">
                  <v-btn
                    color="accent"
                    :to="{ name: 'methodology' }"
                    min-width="90%"
                    depressed
                    rounded
                    >Mehr Informationen</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Toolstable"
};
</script>

<style scoped>
.chapter-color {
  background-color: #f5f5f5;
  min-height: 20em;
}
.component-color {
  background-color: #f5f5f5;
}
</style>
